module.exports = __webpack_public_path__ + "static/media/check-circle.2f5583ea.svg";